import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const DashboardApexChart = () => {
  const result = useSelector((state) => state.admin);
  const { montlyProfitData, montlyProfitcategories, netProfitValue } =
    result || {};

  const [state, setState] = useState({
    series: [
      {
        name: "Net Profit",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "100%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: `€ ${netProfitValue?.toFixed(2)}`,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "€" + val.toLocaleString("en-US");
          },
        },
      },
    },
  });

  useEffect(() => {
    if (montlyProfitData && montlyProfitcategories) {
      setState((prev) => ({
        ...prev,
        series: [{ name: "Net Profit", data: montlyProfitData }],
        options: {
          ...prev.options,
          xaxis: { categories: montlyProfitcategories },
        },
      }));
    }
  }, [montlyProfitData, montlyProfitcategories]);

  return (
    <div className="mixed-chart w-100">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height="350px"
      />
    </div>
  );
};

export default DashboardApexChart;
